import Vue from 'vue';
import { apiPath } from '../constants';

const negativeKeywordResource = Vue.resource(
  `${apiPath}/adbazaar{/v}{/type}{/itemId}{/action}/`,
  {},
  {
    getNegativeKeywords: {
      method: 'GET',
      params: { type: 'campaigns', action: 'negative-keywords' },
    }, // Campaign should be refactored and seprated
    addNegativeKeyword: {
      method: 'POST',
      params: { type: 'campaigns', action: 'negative-keywords' },
    },
  },
);

export default negativeKeywordResource;
